// Import the functions you need from the SDKs you need
// eslint-disable-next-line import/no-unresolved
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyB3R3qIY8oDPvl9D_7MZPmlik8gs_qD4iY",
  authDomain: "fundindia-e88c0.firebaseapp.com",
  projectId: "fundindia-e88c0",
  storageBucket: "fundindia-e88c0.appspot.com",
  messagingSenderId: "330544221700",
  appId: "1:330544221700:web:a8aa14af9fa9c7256eef51",
  measurementId: "G-NHRFZK738S",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;
